import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Tippy from '@tippyjs/react';

import client from '../../../shared/api/client';
import NavMenuIcon from '../../shared/Icons/NavMenuIcon';

const CIRCUMFERENCE = 113.1; // 2π·18

const OnboardingNavItem = ({ item, teamId, isExpanded }) => {
  const [progress, setProgress] = useState({ tasksDone: 0, tasksTotal: 0 });

  useEffect(() => {
    if (!item) return;
    let active = true;
    client
      .get(`/teams/${teamId}/onboarding/progress`)
      .then((res) => { if (active) setProgress(res.data || { tasksDone: 0, tasksTotal: 0 }); })
      .catch(() => {});
    return () => { active = false; };
  }, [item, teamId]);

  if (!item) return null;

  const { tasksDone, tasksTotal } = progress;
  const hasProgress = tasksTotal > 0;
  const remaining = tasksTotal - tasksDone;
  if (hasProgress && remaining <= 0) return null;

  const dashoffset = hasProgress ? CIRCUMFERENCE * (1 - tasksDone / tasksTotal) : CIRCUMFERENCE;
  const label = hasProgress
    ? `${item.toolTip} — ${remaining} ${remaining === 1 ? 'task' : 'tasks'} remaining`
    : item.toolTip;

  return (
    <div className={'nav-v2-onboarding main-menu-link d-flex align-items-center position-relative' + (item.active ? ' active' : '')}>
      <Tippy placement="right" content={item.toolTip} disabled={isExpanded}>
        <a href={item.href} className="stretched-link d-flex align-items-center" aria-label={label}>
          <span className="nav-v2-onboarding-icon">
            {hasProgress && (
              <svg className="nav-v2-onboarding-ring" width="40" height="40" viewBox="0 0 40 40" aria-hidden="true">
                <circle className="nav-v2-onboarding-ring-track" cx="20" cy="20" r="18" fill="none" strokeWidth="2.5" />
                <circle className="nav-v2-onboarding-ring-progress" cx="20" cy="20" r="18" fill="none" strokeWidth="2.5"
                        strokeLinecap="round" strokeDasharray={CIRCUMFERENCE} strokeDashoffset={dashoffset} />
              </svg>
            )}
            <NavMenuIcon xlinkHref={item.xlinkHref} />
            {hasProgress && (
              <span className="nav-v2-onboarding-badge" aria-hidden="true">{remaining}</span>
            )}
          </span>
          {isExpanded && <span className="menu-label">{item.toolTip}</span>}
        </a>
      </Tippy>
    </div>
  );
};

OnboardingNavItem.propTypes = {
  item: PropTypes.shape({
    toolTip: PropTypes.string,
    href: PropTypes.string,
    xlinkHref: PropTypes.string,
    active: PropTypes.bool,
  }),
  teamId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  isExpanded: PropTypes.bool,
};
OnboardingNavItem.defaultProps = { item: null, isExpanded: false };

export default OnboardingNavItem;
